export default {"src":"/_next/static/media/phone-frame.d4b6b62a.svg","height":729,"width":366,"blurWidth":0,"blurHeight":0};